<template>
  <el-dialog
    v-model="isVisible"
    :title="title"
    :width="width"
    center
    @closed="onCancel"
  >
    <div class="confirm-dialog-content">
      <slot>{{ message }}</slot>
    </div>
    <template #footer>
      <div class="dialog-footer">
        <el-button class="full-width-button" @click="onCancel">
          {{ cancelText }}
          <KeyenceHTHardKeyButton
            v-if="isKeyenceEnterpriseBrowser"
            :hardkey="KeyenceHardKey.BACKSPACE"
            :function="onCancel"
            :visible="isVisible"
            :newLayer="true"
          />
        </el-button>
        <el-button class="full-width-button" :type="confirmType" @click="onConfirm">
          {{ confirmText }}
          <KeyenceHTHardKeyButton
            v-if="isKeyenceEnterpriseBrowser"
            :hardkey="confirmHardKey || KeyenceHardKey.ENTER"
            :function="onConfirm"
            :visible="isVisible"
            :newLayer="false"
          />
        </el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component'
import { Emit, Prop, Watch } from 'vue-property-decorator'
import KeyenceHTHardKeyButton from '@/components/keyenceHT/hardkeys/KeyenceHTHardKeyButton.vue'
import { KeyenceHardKey } from '@/utils/keyenceHT/keyenceHardKeyEventHandler'
import { isKeyenceEnterpriseBrowser } from '@/utils/keyenceHT/keyenceModules'

@Options({
  name: 'ConfirmDialog',
  components: {
    KeyenceHTHardKeyButton,
  },
  emits: ['update:modelValue', 'confirm', 'cancel'],
})
export default class ConfirmDialog extends Vue {
  @Prop({ type: Boolean, default: false })
  modelValue!: boolean

  @Prop({ type: String, default: '' })
  title!: string

  @Prop({ type: String, default: '' })
  message!: string

  @Prop({ type: String, default: 'OK' })
  confirmText!: string

  @Prop({ type: String, default: 'Cancel' })
  cancelText!: string

  @Prop({ type: String, default: 'primary' })
  confirmType!: 'primary' | 'danger' | 'warning' | 'success' | 'info'

  @Prop({ type: String, default: '90%' })
  width!: string

  @Prop({ type: String })
  confirmHardKey?: string

  KeyenceHardKey = KeyenceHardKey

  get isVisible(): boolean {
    return this.modelValue
  }

  set isVisible(value: boolean) {
    this.updateModelValue(value)
  }

  get isKeyenceEnterpriseBrowser(): boolean {
    return isKeyenceEnterpriseBrowser()
  }

  @Emit('update:modelValue')
  updateModelValue(value: boolean): boolean {
    return value
  }

  @Emit('confirm')
  onConfirm(): void {
    this.isVisible = false
  }

  @Emit('cancel')
  onCancel(): void {
    this.isVisible = false
  }
}
</script>

<style lang="scss" scoped>
.confirm-dialog-content {
  text-align: center;
  padding: 20px;
}

.dialog-footer {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 12px;
  width: 100%;
}

.full-width-button {
  width: 100%;
  min-height: 60px;
}
</style>
